import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgChartsModule} from 'ng2-charts';

// Your components
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ToastrModule} from "ngx-toastr";
import {DeliveryDashboardComponent} from "./components/delivery-dashboard/delivery-dashboard.component";
import {EditDeliveryModalComponent} from "./components/edit-delivery-modal/edit-delivery-modal.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatNativeDateModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatDialogModule} from "@angular/material/dialog";
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ProjectNavBarComponent } from './components/project-nav-bar/project-nav-bar.component';
import {ProjectNavBarModule} from "./components/project-nav-bar/project-nav-bar.module";
import { RiderTripsComponent } from './components/rider-trips/rider-trips.component';
import {MatProgressBar} from "@angular/material/progress-bar";

export const ISO_DATE_FORMAT = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [
        AppComponent,
        DeliveryDashboardComponent,
        EditDeliveryModalComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        //core
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,                  // ← needed for <router-outlet>
        AppRoutingModule,
        ProjectNavBarModule,

        // 3rd-party
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 3000,
            closeButton: true,
            preventDuplicates: true,
        }),
        NgChartsModule,

        // Material
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,         // ← import the MODULE, not the class
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatProgressBar

    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: ISO_DATE_FORMAT
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
